import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepOneGroups.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getGroupsData = createSelector(
  (state) => state.memoryStepOneGroups.data.memoryStepOneGroups,
  (groups = []) => groups
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepOneGroups.data.currency,
  (currency = {}) => currency
);

export default {
  getCurrencyData,
  getGroupsData,
  getHasLoaded,
};
